import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import PDFVoucherView from '../../../../Vouchers/sections/Shared/PDFVoucherView';
import vouchersData from '../../../../../data/vouchers/vouchersData.json';

const samplePDFVoucherData = vouchersData.sampleVoucher || {};

const SampleVoucherPdfModal = ({
  isOpen,
  onClose,
  effectiveLogo,
  companyName,
  agent,
  userData
}) => {
  // Lock body scroll when preview modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen || typeof document === 'undefined') return null;

  return createPortal(
    <div
      onClick={onClose}
      className="fixed inset-0 z-[99999] bg-slate-950/75 backdrop-blur-xs flex items-center justify-center p-2 sm:p-4 md:p-6 animate-fadeIn"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-slate-100 rounded-2xl sm:rounded-3xl shadow-2xl w-full max-w-4xl max-h-[92vh] flex flex-col overflow-hidden border border-slate-200 relative z-10"
      >
        {/* Modal Top Header Bar */}
        <div className="bg-white px-4 sm:px-6 py-3.5 border-b border-slate-200 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-xl bg-primary/10 text-primary flex items-center justify-center font-bold text-xs">
              PDF
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h3 className="text-sm sm:text-base font-medium text-slate-800">
                  Sample Voucher Preview
                </h3>
                <span className="text-[10px] font-mono font-medium px-2 py-0.5 rounded-md bg-teal-50 text-[#067978] border border-teal-200">
                  bysid
                </span>
              </div>
              <p className="text-[11px] text-slate-500 font-normal">
                Pre-loaded sample voucher rendered with the agency PDF template
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              type="button"
              data-tour="pdf-close-btn"
              onClick={onClose}
              className="w-8 h-8 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-600 flex items-center justify-center transition-colors cursor-pointer"
              aria-label="Close modal"
            >
              <X size={18} />
            </button>
          </div>
        </div>

        {/* Modal Body: Scrollable PDF Voucher Preview */}
        <div className="flex-1 overflow-y-auto p-3 sm:p-6 bg-slate-100 flex justify-center no-scrollbar">
          <div className="bg-white shadow-lg rounded-xl overflow-hidden max-w-[800px] w-full my-auto border border-slate-200/80">
            <PDFVoucherView
              data={samplePDFVoucherData}
              bookingId="bysid"
              logo={effectiveLogo}
              agentName={companyName}
              agentEmail={agent?.email || userData?.email || 'youremail@youremail.com'}
              agentPhone={agent?.phone || userData?.phone || '+91 92345 67890'}
              agentAddress={agent?.address || userData?.address || 'Your Address Here, Your City Here - 400002'}
              city={agent?.city || userData?.city || 'Jaipur'}
              pincode={agent?.pincode || userData?.pincode || '400002'}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SampleVoucherPdfModal;
